module.exports = {"apiUrl":"https://api.giacomobrunoph.com","cdnUrl":"https://static.giacomobrunoph.com","breakpoint":767}


//////////////////
// WEBPACK FOOTER
// ./src/config.prod.json
// module id = 41
// module chunks = 0